// Copyright (c) 2020-2021 Sendanor. All rights reserved.

/**
 * The size of undo history when editing
 */
export const UNDO_HISTORY_LENGTH = 100;

